/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_plan_id: z.string().uuid(),
  preparer_user_id: z.string().uuid(),
  deleted_at: z.number().nullable(),
  executed_at: z.number().nullable(),
  ambient_temperature: z.number().nullable(),
  ambient_humidity: z.number().nullable(),
  finished_at: z.number().nullable(),
  remarks: z.string().nullable(),
  created_by_user_id: z.string().uuid(),
  has_stir_execution: z.boolean().nullable(),
});
const create = base.extend({
  executed_at: base.shape.executed_at.optional(),
  ambient_temperature: base.shape.ambient_temperature.optional(),
  ambient_humidity: base.shape.ambient_humidity.optional(),
  finished_at: base.shape.finished_at.optional(),
  remarks: base.shape.remarks.optional(),
  has_stir_execution: base.shape.has_stir_execution.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
  created_by_user_id: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
  created_by_user_id: true,
})
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
  preparer_user_id: true,
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ConstructionBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ConstructionBase = z.infer<typeof base>;
export type ConstructionBasePutPayload = z.infer<typeof put>;
export type ConstructionBasePatchPayload = z.infer<typeof patch>;
export type ConstructionBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ConstructionBaseCreateAttributes = z.infer<typeof create>;
export type ConstructionBaseUpdateAttributes = z.infer<typeof update>;
export type ConstructionBaseCacheAttributes = z.infer<typeof cache>;
export type ConstructionBaseCachesAttributes = z.infer<typeof caches>;